import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { get } from 'lodash-es'

import './RadioButtonComponent.scss'

const RadioButtonComponent = (props) => {
  const { id, name, checked, onChange, value, label, styles } = props

  const textStyle = get(styles, 'text')
  const passiveColor = get(styles, 'passiveColor', '#AAAAAA')
  const activeColor = get(styles, 'activeColor', '#1EC95B')

  const color = checked ? activeColor : passiveColor

  return (
    <div style={textStyle} className="radio-button-component">
      <label className="label-wrapper" htmlFor={id}>
        <input
          id={id}
          type="radio"
          name={name}
          onChange={onChange}
          checked={checked}
          value={value}
          className="input-radio-hidden"
        />
        <span
          style={{ borderColor: color }}
          className={classnames('input-radio-visible', { checked })}
        >
          <span style={{ background: color }} />
        </span>
        <span className="label-value">{label}</span>
      </label>
    </div>
  )
}

RadioButtonComponent.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string,
  styles: PropTypes.shape({
    text: PropTypes.object,
    passiveColor: PropTypes.string,
    activeColor: PropTypes.string,
  }),
}

export default RadioButtonComponent
